module.exports = __webpack_public_path__ + "media/assets/images/landing/ведомство_1-2b9d16f75d4a5b60c7dc909b595cb2d9.png";